@if (rhestrGwallau?.length > 0) {
  @if (rhestrGwallau) {
    <ul class="negeseuon">
      @for (gwall of rhestrGwallau; track gwall) {
        <li>
          {{ gwall }}
        </li>
      }
    </ul>
  }
}

@if (gwallUnigol) {
  <ul class="neges-unigol">
    <li>
      {{ gwallUnigol | translate }}
    </li>
  </ul>
}